  <p-card>
    @if (taStatus() === 'PendingApproval') {
      <manage-ta-approval></manage-ta-approval>
    } @else if (taStatus() === 'TravelApproved') {
      <manage-ta-travel-approved></manage-ta-travel-approved>
    } @else if (taStatus() === 'TravelRejected') {
      <manage-ta-info [message]="'TA has been rejected.'"></manage-ta-info>
    } @else if (taStatus() === 'PendingAcquittal') {
      <manage-ta-acquittal></manage-ta-acquittal>
    } @else if (taStatus() === 'AcquittalComplete') {
      <manage-ta-acquittal-approval></manage-ta-acquittal-approval>
    } @else if (taStatus() === 'PendingCancelApproval') {
      <manage-ta-cancel-approval></manage-ta-cancel-approval>
    } @else if (taStatus() === 'AcquittalApproved') {
      <manage-ta-finalise></manage-ta-finalise>
    } @else if (taStatus() === 'CancelApproved') {
      <manage-ta-cancel-finalise></manage-ta-cancel-finalise>
    } @else if (taStatus() === 'Finalised') {
      <manage-ta-info [message]="'TA finalised.'">
        <ta-approvals-table [taSubmission]="store.taSubmission()" heading="Approvals"></ta-approvals-table>
      </manage-ta-info>
      @if (!taSubmissionDatasource.isFlightOnly()) {
        <manage-ta-day-trip-breakdown></manage-ta-day-trip-breakdown>
        <!-- Need to show prepayment actions as these can still be unactioned by this stage -->
        <manage-ta-payment-actions></manage-ta-payment-actions>
      }
    } @else if (taStatus() === 'Cancelled') {
      <manage-ta-info [message]="'TA cancelled.'"></manage-ta-info>
      @if (!taSubmissionDatasource.isFlightOnly()) {
        <manage-ta-day-trip-breakdown></manage-ta-day-trip-breakdown>
        <!-- An approved cancellation can be finalised before compliance has recorded the deduction,
             so the overpayment action has to stay reachable here too -->
        <manage-ta-payment-actions></manage-ta-payment-actions>
      }
      <itinerary-difference-comparison></itinerary-difference-comparison>
    } @else if (taStatus() === 'Deleted') {
      <manage-ta-info [message]="'This TA has been deleted.'"></manage-ta-info>
    } @else {
      <manage-ta-info [message]="'TA status: ' + (!!taStatus() ? toTAStatusText(taStatus()!) : 'Unknown')"></manage-ta-info>
    }

    <div class="w-full flex justify-end gap-4 mt-4">
      @if (taStatus() === 'InProgress') {
        @if (permissionService.canEditTaPrimary()) {
          <p-button [severity]="'primary'" styleClass="w-64" (onClick)="reviewTa()">
            <i class="fa-regular fa-magnifying-glass pl-[1px]"></i>
            <span class="flex-1">Go to Review Page</span>
          </p-button>
        } @else {
          <p-button [severity]="'primary'" styleClass="w-64" (onClick)="viewTa()">
            <i class="fa-regular fa-magnifying-glass pl-[1px]"></i>
            <span class="flex-1">Go to View Page</span>
          </p-button>
        }
      }
      <div class="flex-1"></div>
      <ta-audit-log-button [taSubmission]="store.taSubmission()"></ta-audit-log-button>
      @if (canCancel()) {
        <p-button [severity]="'danger'" styleClass="w-64" (onClick)="cancelSubmissionClicked()">
          <i class="pi pi-trash pl-[1px]"></i>
          <span class="flex-1">Cancel TA Application</span>
        </p-button>
      }
    </div>
  </p-card>

